import React from "react";

interface SearchInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClear: () => void;
  placeholder?: string;
  ref: React.RefObject<HTMLInputElement>;
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  onClear,
  ref,
  onKeyDown,
  placeholder = "Search by Serial Number...",
}) => {
  return (
    <div className="w-full md:w-72 relative">
      <div
        className="
          relative flex items-center gap-2
          bg-white border border-blue-400
          rounded-xl px-3 py-2
          shadow-sm
          transition-all
          hover:border-gray-400
          focus-within:border-blue-500
          focus-within:ring-2 focus-within:ring-blue-300
        "
      >
        <svg
          className="w-4 h-4 text-gray-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15z"
          />
        </svg>

        <input
          ref={ref}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          className="
            flex-1 bg-transparent outline-none
            text-gray-700 placeholder-gray-400
          "
        />

        {value && (
          <button
            type="button"
            onClick={onClear}
            className="
              text-gray-400 absolute top-1/2 right-0 -translate-y-1/2 hover:text-gray-600 
              transition p-1 rounded-full
              active:scale-95
            "
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};
